import { Component, Inject } from "@angular/core";
import { IPopup } from "src/app/services/popup/popup-ref";
import { DATA, POPUP } from "src/app/services";
import { PopupData } from "./popup-data";

@Component({
    template: `<div class="grid gap-2">
                <span>{{data.message}} <xena-icon name="far-hand-peace"></xena-icon></span>
                <div class="text-right">
                    <xena-button (click)="close()">Close</xena-button>
                <div>
            </div>`,
    standalone: false
})
export class PopupDialogExampleComponent {
    constructor(@Inject(POPUP) private popup: IPopup, @Inject(DATA) public data: PopupData) { }

    close() {
        this.popup.close();
    }
}
